const leaveEnquiryHeaders = {
  RequestDate: 'Request Date',
  RequestType: 'Request Type',
  'From Date': 'From Date',
  'To Date': 'To Date',
  Days: 'Days',
  Approver: 'Approver',
  Status: 'Status',
};
export const LEAVE_TYPES_BADGE_STYLES = {
  'ANNUAL LEAVE': {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
  },
  'ANNUAL LEAVE - HALF DAY': {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
  },
  'SICK LEAVE': {
    backgroundColor: '#FDF2FA',
    borderColor: '#FCCEEE',
    fontColor: '#C11574',
  },
  'SICK LEAVE HALF DAY': {
    backgroundColor: '#FDF2FA',
    borderColor: '#FCCEEE',
    fontColor: '#C11574',
  },
  'COMPASSIONATE LEAVE': {
    backgroundColor: '#FEF6EE',
    borderColor: '#F9DBAF',
    fontColor: '#B93815',
  },
  'COMPASSIONATE LEAVE-HD': {
    backgroundColor: '#FEF6EE',
    borderColor: '#F9DBAF',
    fontColor: '#B93815',
  },
  'MATERNITY LEAVE': {
    backgroundColor: '#F8F9FC',
    borderColor: '#D5D9EB',
    fontColor: '#363F72',
  },
  'PATERNITY LEAVE': {
    backgroundColor: '#F0F9FF',
    borderColor: '#B9E6FE',
    fontColor: '#026AA2',
  },
  'UNPAID LEAVE': {
    backgroundColor: '#ECFDFF',
    borderColor: '#A5F0FC',
    fontColor: '#0E7090',
  },
  'UNPAID LEAVE - HALF DAY': {
    backgroundColor: '#ECFDFF',
    borderColor: '#A5F0FC',
    fontColor: '#0E7090',
  },
  'STUDY LEAVE': {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
  },
  'HAJJ LEAVE': {
    backgroundColor: '#FEFDF0',
    borderColor: '#FEEE95',
    fontColor: '#854A0E',
  },
  'MARRIAGE LEAVE': {
    backgroundColor: '#F4F3FF',
    borderColor: '#D9D6FE',
    fontColor: '#5925DC',
  },
  // OTHER LEAVE TYPES
  'OTHER LEAVE': {
    backgroundColor: '#F0F9FF',
    borderColor: '#B9E6FE',
    fontColor: '#026AA2',
  },
  'WORK FROM HOME': {
    backgroundColor: '#FFF1F3',
    borderColor: '#FECDD6',
    fontColor: '#C01048',
  },
};

export const LEAVE_STATUS_BADGE_STYLES = {
  Approved: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
    dotColor: '#17B26A',
  },
  Rejected: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
    dotColor: '#F04438',
  },
  Pending: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
    dotColor: '#2E90FA',
  },
};

export default leaveEnquiryHeaders;
